import axios from "axios";

// ======================= Константы =======================
const API_HOUSES_URL = "https://pablohouse.su:88";
const API_MAIN_URL = "https://pablohouse.su:8080"; // основной бекенд

// ======================= Axios инстансы =======================
const housesApi = axios.create({
  baseURL: API_HOUSES_URL,
  headers: { "Content-Type": "application/json" },
});

const mainApi = axios.create({
  baseURL: API_MAIN_URL,
  headers: { "Content-Type": "application/json" },
});

// ======================= Класс API =======================
class UserApi {
  // ---------- Houses ----------
  async buyHouse(homeId: number, userId: string, price: number) {
    const { data } = await housesApi.post("/buyHome", { homeId, userId, price });
    return data;
  }

  async getHouses() {
    try {
      const { data } = await housesApi.get("/getHome");
      return data;
    } catch (e) {
      console.error("Ошибка при получении домов:", e);
    }
  }

  async getHouseById(homeId: number) {
    try {
      const { data } = await housesApi.get(`/getHome?id=${homeId}`);
      return data;
    } catch (e) {
      console.error("Ошибка при получении дома по ID:", e);
    }
  }

  async getHomes() {
    try {
      const { data } = await housesApi.get("/getHomes");
      return data;
    } catch (e) {
      console.error("Ошибка при получении списка домов:", e);
    }
  }

  // ---------- User ----------
  async getUser(id: string) {
    try {
      const { data } = await mainApi.get(`/user/${id}`);
      return data;
    } catch (error) {
      console.error("Ошибка при получении пользователя:", error);
    }
  }

  // ---------- Mining (на API_MAIN_URL) ----------
  async miningGetSlots(userId: string) {
    try {
      const { data } = await mainApi.get(`/mining/getSlots/${userId}`);
      return data;
    } catch (error) {
      console.error("Ошибка при получении слотов:", error);
    }
  }

  async miningGetGpu(userId: number) {
    try {
      const { data } = await mainApi.get(`/mining/getGpu/${userId}`);
      return data;
    } catch (error) {
      console.error("Ошибка при получении видеокарт:", error);
    }
  }

  async miningGetGpuById(gpuId: number) {
    try {
      const { data } = await mainApi.post(`/mining/getGpuById/${gpuId}`);
      return data;
    } catch (error) {
      console.error("Ошибка при получении видеокарты по ID:", error);
    }
  }

  async miningBuySlot(userId: number) {
    try {
      const { data } = await mainApi.post(`/mining/buySlot/${userId}`);
      return data;
    } catch (error) {
      console.error("Ошибка при покупке слота:", error);
    }
  }

  async miningSlotPrice() {
    return "2.500.000";
  }

  async miningInstallGpuToSlot(userId: number, standId: number, cardId: number) {
    try {
      const { data } = await mainApi.post("/mining/installGpu", {
        userId: String(userId), // обязательно строка
        standId,
        cardId,
      });
      return data;
    } catch (error: any) {
      console.error("Ошибка при установке GPU:", error.response?.data || error.message);
      throw error;
    }
  }

  async miningPourGpu(userId: number, gpuId: number) {
    try {
      const { data } = await mainApi.post("/mining/freezeGpu", {
        userId: String(userId), // строка
        cardId: Number(gpuId), // число
      });
      return data;
    } catch (error: any) {
      console.error("Ошибка при заливке GPU:", error.response?.data || error.message);
      throw error;
    }
  }

  async withdrawBitcoin(userId: number, cardId: number) {
    try {
      const { data } = await mainApi.get(`/mining/withdrowBitcoin/${cardId}/${userId}`);
      return data;
    } catch (error: any) {
      console.error("Ошибка при выводе Bitcoin:", error.response?.data || error.message);
      throw error;
    }
  }

  async miningPullGpu(userId: number, gpuId: number) {
    try {
      const { data } = await mainApi.get(`/mining/pullGpu/${gpuId}/${userId}`);
      return data;
    } catch (error: any) {
      console.error("Ошибка при снятии карты:", error.response?.data || error.message);
      throw error;
    }
  }
}

const userApi = new UserApi();
export default userApi;